import { useDebugValue, useEffect } from 'react';
import { useMeasuredCookieState } from './useMeasuredCookieState';
import { useMeasured } from './useMeasured';
export function useMeasuredCookie(cookieType, { defaultSize: defaultSizeProp, cookieDim = 'both', version = 0, measureOptions }) {
    const { containerSize, defaultSizeForPlatform, updateContainerSize } = useMeasuredCookieState(cookieType, cookieDim, defaultSizeProp, {
        throttle: 0,
        throttleOptions: {}
    });
    useDebugValue(containerSize, (size)=>`Width: ${size === null || size === void 0 ? void 0 : size.width}, height: ${size === null || size === void 0 ? void 0 : size.height}`);
    const { ref, dimensions } = useMeasured(measureOptions !== null && measureOptions !== void 0 ? measureOptions : {
        throttle: 250,
        throttleOptions: {
            trailing: true
        }
    });
    useEffect(()=>{
        updateContainerSize(dimensions);
    }, [
        dimensions,
        updateContainerSize
    ]);
    return {
        ref,
        dimensions: containerSize !== null && containerSize !== void 0 ? containerSize : defaultSizeForPlatform
    };
}
